module.exports = __webpack_public_path__ + "static/sponsor-02-3ba1d6671a1caf7cca3c46aec0d7b247.png";